<template>
  <Toast />
  <router-view />
</template>

<script setup lang="ts">
import Toast from "primevue/toast";
</script>

<style>
body {
  margin: 0;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  background-color: var(--p-content-background);
  color: var(--p-text-color);
}
</style>
